import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySales = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/sales',
        
        branches: [],
        branchesLoading: false,

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,

        partTypes: [],
        partTypesLoading: false,
        partTypeLoading: false,

        partBrands: [],
        partBrandsLoading: false,
        partBrandLoading: false,

        partOrigins: [],
        partOriginsLoading: false,
        partOriginLoading: false,

        partQualities: [],
        partQualitiesLoading: false,
        partQualityLoading: false,

        measurements: [],
        measurementsLoading: false,
        measurementLoading: false,

        paymentMethods: [],
        paymentMethodsLoading: false,

        expenseTypes: [],
        expenseTypesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
        
        partCategories: state => state.partCategories,

        partTypes: state => state.partTypes,

        partBrands: state => state.partBrands,

        partOrigins: state => state.partOrigins,

        partQualities: state => state.partQualities,

        measurements: state => state.measurements,
        
        paymentMethods: state => state.paymentMethods,

        expenseTypes: state => state.expenseTypes,
    },
};
